import { api } from '@/global/api'
import { GetFilterResponse } from '@/modules/accredited-establishments/api/types'

export interface GetAddressArgs {
  search: string
}

export const getAddressFilterOptions = async ({
  search
}: GetAddressArgs): Promise<GetFilterResponse> => {
  const { data } = await api.get<GetFilterResponse>(
    `/site_accredited_network/maps/address/search?q=${search}`
  )
  return data
}
